module.exports = __webpack_public_path__ + "static/media/9DESA30.74bde178.jpg";